import { render, staticRenderFns } from "./_collect.vue?vue&type=template&id=5f1481c2&scoped=true"
import script from "./_collect.vue?vue&type=script&lang=js"
export * from "./_collect.vue?vue&type=script&lang=js"
import style0 from "./_collect.vue?vue&type=style&index=0&id=5f1481c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1481c2",
  null
  
)

export default component.exports